var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{style:(_vm.drawer ? 'padding: 75px 0px 0px 56px;' : 'padding: 75px 0px 0px;')},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }